export default __webpack_public_path__ + "static/media/mens.4a3bf1d0.png";